export default {
  tableData: {
    results: [],
    count: 0
  }
};
